export default __webpack_public_path__ + "static/media/Izmir-Regular.5dfcbace.woff2";